/**
 * Local development entry point.
 * In production, ExtractionApp is loaded as a remote module by the xplatform
 * shell. This standalone entry provides its own XPlatformProvider so the module
 * can still be developed in isolation on port 5001.
 */
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { XPlatformProvider } from '@xplatform/design-system';
import './styles/layers.css';
import '@mantine/core/styles.layer.css';
import '@mantine/dates/styles.layer.css';
import '@xplatform/design-system/styles.layer.css';
import './config/i18n';
import ExtractionApp from './ExtractionApp';
import './index.scss';

createRoot(document.getElementById('root')!).render(
    <XPlatformProvider>
        <BrowserRouter>
            <ExtractionApp />
        </BrowserRouter>
    </XPlatformProvider>
);
